// API Configuration (original structure)
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:9211',
  // Top-level constants used across the app
  PLANT_ID: 'e91578d0e2',
  DP_ACTIVE_POWER_ID: '301cb5cebb',
  WS_LIVE_POA_POWER_DENSITY_ID: '7677bb20bd',
  // Endpoints
  ENDPOINTS: {
    // Authentication
    LOGIN: '/auth/login',
    REFRESH_TOKEN: '/token',
    USER_PROFILE: '/user/profile',
    // KPI Readings
    KPI_READINGS_BY_TAGS: '/apollo_kpireadings/kpi_readings_by_tags_live',
    GET_FOR_GRAPH: '/apollo_kpireadings/get_for_graph',
    GET_FOR_ENERGY_LOSS: '/apollo_kpireadings/get_for_energy_loss_app',
    GET_AGGREGATED_EYA: '/apollo_kpireadings/get_aggregated_eya',
    GET_AGGREGATED_KPI: '/apollo_kpireadings/get_aggregated_kpi',
    FETCH_DATA_ACQUISITION_STATUS: '/apollo_kpireadings/fetch_data_acquisition_status',
    // OMP Readings / Asset
    OMP_DATA_BY_TAGS: '/apollo_omp_readings/fetch_omp_data_by_tags',
    FETCH_APO_ASSET_DATA: '/apollo_omp_readings/fetch_apo_asset_data',
    FETCH_APO_ASSET_ATTR_DATA: '/apollo_omp_readings/fetch_apo_asset_attr_data',
    FETCH_APO_ASSET_DATA_FOR_TABLE: '/apollo_omp_readings/fetch_apo_asset_data_for_asset_table',
    // PVSyst Data
    FETCH_PVSYST_DATA: '/apo_pvsyst/fetch_pvsyst_data',
    GET_PVSYST_DATA_FOR_EL: '/apo_pvsyst/get_pvsyst_data_for_el',
    // Power Forecast
    INTRA_DAY_FORECAST: '/power_forecast/get_intra',
    INTER_DAY_FORECAST: '/power_forecast/get_inter',
    WEEK_AHEAD_FORECAST: '/power_forecast/get_weekahead',
    MONTH_AHEAD_FORECAST: '/power_forecast/get_monthahead',
    HISTORICAL_FORECAST: '/power_forecast/get_historic',
    // User Management
    USERS: '/users',
    APO_USER_PLANT_ACCESS: '/apo_user_plant_access',
    APO_USER_AUTHORITY: '/apo_user_authority',
  },
  // Request timeout
  TIMEOUT: 30000,
  // Cache TTL values (in milliseconds)
  CACHE_TTL: {
    BRIEF: 60_000,        // 1 minute
    SHORT: 120_000,       // 2 minutes
    MEDIUM: 300_000,      // 5 minutes
    LONG: 86_400_000,     // 24 hours
  }
};